import { useState } from 'react';
import { Body1, Card, Link as FluentLink, Subtitle2 } from '@fluentui/react-components';
import type { TTaskActivity } from '../../tasks/types';
import { RECENT_ACTIVITIES_MORE_LABEL } from '../constants';
import RecentActivitiesDialog from './RecentActivitiesDialog';
import TaskActivityRow from './TaskActivityRow';

type TProps = {
  projectId: string;
  activities: TTaskActivity[];
};

const RecentActivitiesCard = ({ projectId, activities }: TProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  return (
    <>
      <Card size="large" className="min-w-0 flex-[2_1_360px]">
        <div className="flex items-center justify-between">
          <Subtitle2>Recent activities</Subtitle2>
          {activities.length > 0 && (
            <FluentLink onClick={() => setIsDialogOpen(true)}>{RECENT_ACTIVITIES_MORE_LABEL}</FluentLink>
          )}
        </div>

        {activities.length ? (
          <div className="flex flex-col">
            {activities.map((activity) => (
              <TaskActivityRow
                key={`${activity.task._id}-${activity.createdDate}-${activity.type}`}
                projectId={projectId}
                activity={activity}
              />
            ))}
          </div>
        ) : (
          <div className="flex grow flex-col items-center justify-center py-6 text-center">
            <Body1>No recent activities.</Body1>
          </div>
        )}
      </Card>
      <RecentActivitiesDialog projectId={projectId} isOpen={isDialogOpen} setIsOpen={setIsDialogOpen} />
    </>
  );
};
export default RecentActivitiesCard;
